import React from 'react'
import { BREAKPOINT_WIDTHS } from 'shared/constants/breakpoints'

// Та же ширина, на которой основной сайт переключается на таббар
export const MOBILE_BREAKPOINT = BREAKPOINT_WIDTHS.phone

// matchMedia, а не window.innerWidth: раскладка из JS переключается ровно
// на той же ширине, что и медиазапросы в стилях
export const useIsMobile = (breakpoint: number = MOBILE_BREAKPOINT): boolean => {
  const query = `(max-width: ${breakpoint}px)`

  const [isMobile, setIsMobile] = React.useState<boolean>(
    () => window.matchMedia(query).matches
  )

  React.useEffect(() => {
    const mediaQuery = window.matchMedia(query)
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches)

    setIsMobile(mediaQuery.matches)
    mediaQuery.addEventListener('change', onChange)

    return () => mediaQuery.removeEventListener('change', onChange)
  }, [query])

  return isMobile
}
